import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { WnlManagerService } from '../wnl-manager.service';
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { NeurologicalFormGroup } from 'src/app/calvin-emr-shared/models/assessments/neurological.model';
import { FormOption } from 'src/app/shared/models/form-option.model';

@Component({
  selector: 'app-neurological-form',
  templateUrl: './neurological-form.component.html',
  styleUrls: ['./neurological-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxGroupComponent,
    EmrCheckboxComponent
  ],
})
export class NeurologicalFormComponent {
  formGroup = input.required<NeurologicalFormGroup>();
  patient = input.required<Patient>();

  wnlManager = new WnlManagerService();
  wnlManagerOB = new WnlManagerService();

  constructor() {
    this.reset();
  }

  reset() {
    this.wnlManager.setControls(
      [
        { control: 'handGrips', default: 'WNL', wnl: false },
        { control: 'lePushPull', default: 'WNL', wnl: false },
        { control: 'rue', default: 'Full sensation', wnl: false },
        { control: 'rle', default: 'Full sensation', wnl: false },
        { control: 'lle', default: 'Full sensation', wnl: false },
        { control: 'lue', default: 'Full sensation', wnl: false },
        { control: 'tremors', default: [], wnl: false },
      ]
    );
  }



  get handGripsDefault() {
    return this.wnlManager.controlColl['handGrips'].default;
  }

  get lePushPullDefault() {
    return this.wnlManager.controlColl['lePushPull'].default;
  }

  get sensationDefault() {
    return this.wnlManager.controlColl['rue'].default;
  }

  extremityStrengthOptions = [
    new FormOption('Moderate'),
    new FormOption('Weak'),
    new FormOption('WNL'),
  ];

  sensationOptions = [
    new FormOption('Numbness'),
    new FormOption('Tingling'),
    new FormOption('Full sensation'),
  ];

  tremorsOptions = [
    new FormOption('RUE', 'rue'),
    new FormOption('RLE', 'rle'),
    new FormOption('LLE', 'lle'),
    new FormOption('LUE', 'lue'),
  ];
}
